import { registerQuery, useQuery } from 'data-fetching-client';
import { useMemo } from 'react';
import { fetchTeamsByIds } from '../api/teams';
const TEAMS_BY_IDS = registerQuery({
  fieldName: 'teamsByIds',
  args: ['teamIds'],
  fetcher: ({
    teamIds
  }) => fetchTeamsByIds(teamIds)
});
export const useTeamNamesByTeamsSelectValue = teamSelectValue => {
  const teamIds = teamSelectValue.map(array => Number(array[array.length - 1])).filter(teamId => !Number.isNaN(teamId));
  const {
    data,
    error,
    loading,
    variables
  } = useQuery(TEAMS_BY_IDS, {
    skip: teamIds.length === 0,
    variables: {
      teamIds
    }
  });
  const teamNames = useMemo(() => data && Array.isArray(data.teamsByIds) ? data.teamsByIds.map(team => team.name) : [], [data]);
  return {
    error,
    loading,
    teamNames,
    variables
  };
};